var math = {
    percent: function (value, max) { return (max > 0 ? (value / max) * 100 : 0); },
};
export default math;
